import { render, staticRenderFns } from "./VisorPedido.vue?vue&type=template&id=2203695e&scoped=true"
import script from "./VisorPedido.vue?vue&type=script&lang=js"
export * from "./VisorPedido.vue?vue&type=script&lang=js"
import style0 from "./VisorPedido.vue?vue&type=style&index=0&id=2203695e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2203695e",
  null
  
)

export default component.exports